import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from '../../context/LanguageContext';
import { FiUser, FiLock } from 'react-icons/fi';
import './LoginPage.css';

const LoginPage = () => {
  const [userNumber, setUserNumber] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const { t, language, setLanguage } = useTranslation();
  const navigate = useNavigate();

  const handleLanguageToggle = (newLang) => {
    setLanguage(newLang);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const success = await login({
        user_number: userNumber,
        password: password,
        device_name: 'web'
      });
      if (success) {
        navigate('/cashier');
      }
    } catch (err) {
      setError(err.response?.data?.message || t('common:messages.loginError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="language-selector">
          <button 
            className={language === 'en' ? 'active' : ''} 
            onClick={() => handleLanguageToggle('en')}
          >
            English
          </button>
          <button 
            className={language === 'ar' ? 'active' : ''} 
            onClick={() => handleLanguageToggle('ar')}
          >
            العربية
          </button>
        </div>

        <div className="login-content">
          <div className="login-header">
            <h1>{t('common:auth.appName')}</h1>
            <p>{t('common:auth.welcome')}</p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <div className="input-wrapper">
                <FiUser className="input-icon" />
                <input
                  type="number"
                  value={userNumber}
                  onChange={(e) => setUserNumber(e.target.value)}
                  required
                  autoComplete="off"
                  placeholder={t('common:auth.userNumber')}
                />
              </div>
            </div>

            <div className="form-group">
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  placeholder={t('common:auth.password')}
                />
              </div>
            </div>

            <button 
              type="submit" 
              className={`submit-button ${loading ? 'loading' : ''}`}
              disabled={loading}
            >
              {loading ? t('common:messages.loggingIn') : t('common:auth.loginButton')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
